import { Component, OnInit } from '@angular/core';
import { OAuthServiceService } from 'shared';

@Component({
    selector: 'manage-files',
    templateUrl: './manage-files.component.html',
    styleUrls: ['./manage-files.component.css'],
    standalone: false
})
export class ManageFilesComponent implements OnInit {
 
  public clientHeight: number = 1137; // Default value, can be adjusted as needed
  public ownUserEmail: string = "";

  constructor(
        private oauthService: OAuthServiceService,
    
  ) { }

  ngOnInit() {
    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          this.ownUserEmail = (data as any)?.email;
        }
      }
    });

  }

}
